import { AppConfig } from '../../../services/baseApplication/types';

export const PAGE_APP_CONFIG: AppConfig = {
  appId: 'page-v2',
  appName: 'Page',
  containerType: 'page',
  layoutMode: 'flow',
  supportedClasses: {
    'text': {
      displayName: 'Text',
      description: 'Plain paragraph text',
      category: 'text',
      defaultAttrs: { position: { type: 'flow' } }
    },
    'heading': {
      displayName: 'Heading',
      description: 'Section heading',
      category: 'text',
      defaultAttrs: { position: { type: 'flow' } }
    },
    'callout': {
      displayName: 'Callout',
      description: 'Highlighted callout block',
      category: 'text',
      defaultAttrs: { position: { type: 'flow' } }
    },
    'code': {
      displayName: 'Code Block',
      description: 'Code snippet',
      category: 'text',
      defaultAttrs: { position: { type: 'flow' } }
    },
    'todo': {
      displayName: 'Task',
      description: 'Checkbox task item',
      category: 'interactive',
      defaultAttrs: { position: { type: 'flow' } }
    },
    'action_button': {
      displayName: 'Action Button',
      description: 'Clickable button that triggers an action or command',
      category: 'interactive',
      defaultAttrs: { position: { type: 'flow' } }
    },
    'entity_embed': {
      displayName: 'Entity Embed',
      description: 'Embedded entity card',
      category: 'interactive',
      defaultAttrs: { position: { type: 'flow' } }
    },
    'divider': {
      displayName: 'Divider',
      description: 'Horizontal rule',
      category: 'layout',
      defaultAttrs: { position: { type: 'flow' } }
    },
    'image': {
      displayName: 'Image',
      description: 'Image block',
      category: 'media',
      defaultAttrs: { position: { type: 'flow' } }
    },
  },
  supportedPositionTypes: ['flow'],
  supportsDragDrop: false,
  supportsResize: false,
  supportsRotation: false,
  defaultContainer: { width: undefined, height: undefined, infinite: false },
  editorSelector: '.page-editor-content',
};
